/**
 * Dismiss
 * Alerts
 * @author Oliver Boermans
 */

import $ from "jquery";
import debug from "debug";
const log = debug("alerts");

//
// Config
// ===========
const ALERT_SELECTOR = "[data-alert]";
const ALERT_BUTTON_SELECTOR = 'button';

const hidePanel = function (alertToHide) {
	$(alertToHide).hide();
	$('body').removeClass('has-alert');
};

const dismissAlert = function (instance) {
	const {element, alertApi, alertId} = instance;
	$.get(alertApi, {
		id: alertId
	});
	hidePanel(element);
};

function init (){
	const alertElements = $(ALERT_SELECTOR);
	log(alertElements);
	alertElements.each(function(index, element){
		const alertApi = element.dataset.alertApi;
		const alertId = element.id;
		const alertButton = $(element).find(ALERT_BUTTON_SELECTOR);

		if (alertButton.length) {
			alertButton.on('click', dismissAlert.bind(null, {element, alertApi, alertId}));
		} else {
			log("No site alert button found.");
		}
	});

};

init();




// WEBPACK FOOTER //
// ./project/client/src/core/components/alerts/dismiss.js